module.exports = {
	"id": "FK",
	"name": "Falkland Islands (Malvinas)",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.013868,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": 0.013868,
			"36": 0.048538,
			"37": 0.048538,
			"38": 0.076274,
			"39": null,
			"40": 0.013868,
			"41": null,
			"42": null,
			"43": null,
			"44": null,
			"45": 0.117878,
			"46": null,
			"47": 0.076274,
			"48": 0.10401,
			"49": 1.712698,
			"50": null,
			"51": 0.027736,
			"52": 0.24269,
			"53": 16.010606,
			"54": 4.33375,
			"55": null,
			"56": null,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": null,
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": null,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": 0.013868,
			"22": null,
			"23": null,
			"24": 0.305096,
			"25": 0.228822,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": 0.027736,
			"31": null,
			"32": null,
			"33": 0.013868,
			"34": null,
			"35": null,
			"36": null,
			"37": null,
			"38": 0.027736,
			"39": 0.027736,
			"40": null,
			"41": 0.228822,
			"42": 0.214954,
			"43": null,
			"44": null,
			"45": 0.041604,
			"46": null,
			"47": 1.42147,
			"48": 1.35213,
			"49": 5.110358,
			"50": null,
			"51": null,
			"52": null,
			"3.5": null,
			"3.6": 0.013868
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": 0.027736,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": null,
			"37": 0.013868,
			"38": null,
			"39": 0.013868,
			"40": 0.228822,
			"41": null,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": null
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": null,
			"6": 0.027736,
			"7": 0.048538,
			"8": 0.284294,
			"9": 0.457644,
			"10": 2.849874,
			"3.1": null,
			"3.2": null,
			"5.1": 0.027736,
			"6.1": 0.076274,
			"7.1": null,
			"9.1": 1.830576
		},
		"ios_saf": {
			"8": 0,
			"10": 7.73390203164,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.208419710658,
			"8.1-8.4": 0.385046584097,
			"9.0-9.2": 0.183691948376,
			"9.3": 2.80247972523
		},
		"android": {
			"3": 0,
			"4": 0.00964958139535,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00120619767442,
			"4.1": 0.0348074186047,
			"4.2-4.3": 0.0870185465116,
			"4.4": 0.19953955814,
			"4.4.3-4.4.4": 0.201262697674
		},
		"ie": {
			"6": null,
			"7": null,
			"8": 2.04652009197,
			"9": 4.59946718974,
			"10": 2.19914192933,
			"11": 19.820026789,
			"5.5": null
		},
		"op_mob": {
			"0": 0.0103605340441,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.000287792612335
		},
		"edge": {
			"12": 0.24269,
			"13": 0.908354,
			"14": 0.214954
		},
		"ie_mob": {
			"10": 0.0417148732394,
			"11": 0.169839126761
		},
		"bb": {
			"7": 0,
			"10": null
		},
		"samsung": {
			"0": 5.13555
		},
		"and_uc": {
			"0": 0.128772
		},
		"op_mini": {
			"0": 0.139585673344
		},
		"and_chr": {
			"0": 14.547016
		},
		"and_ff": {
			"0": 0.042924
		}
	},
	"total": 99.849858
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/FK.json
 ** module id = 520
 ** module chunks = 0
 **/